import { ReadonlyRecord } from 'fp-ts/ReadonlyRecord';
import { ProjectListViewMode } from 'src/modules/project-list/types/ProjectListViewMode';

export const PROJECT_LIST_PAGE_SIZE: ReadonlyRecord<ProjectListViewMode, number> = {
  [ProjectListViewMode.LIST]: 100,
  [ProjectListViewMode.GRID]: 6,
};
